import React, { useEffect, useLayoutEffect, useState } from "react";
import { Autocomplete, Box, Grid, IconButton, Modal, Pagination, TextField, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import AuthService from "../../Components/auth/AuthService";
import { useNavigate } from "react-router-dom";
import {
  hideLoading,
  showLoading,
  useLoadingDispatch,
} from "../../context/loadingContext";
import { Button, Table, DatePicker as AntDate, message } from "antd/es";
import { DeleteFilled, DownloadOutlined, EditFilled, PlusCircleFilled } from "@ant-design/icons";
import { AuthReqTypes, DATE_FORMAT, DEFAULT_DATE_FORMAT, discountStatus } from "../../Components/common/constants";
import Message from "../../Components/common/Message";
import config from "../../Components/config";
import dayjs from "dayjs";

const { RangePicker } = AntDate;

const Auth = new AuthService();

export default function DiscountReport() {

  const navigate = useNavigate();
  var layoutDispatch = useLoadingDispatch();
  const currentDate = new Date();
  const [page, setPage] = React.useState(1);
  const [pageChange, setPageChange] = React.useState(false);
  const [limit] = React.useState(50);
  const [totalPages, setTotalPages] = React.useState(0);
  const [totalCount, setTotalCount] = React.useState(null);

  const [loadMessage, setLoadMessage] = React.useState("");
  const [type, setType] = React.useState("");
  const [allDiscounts, setAllDiscounts] = React.useState([]);
  const [dateRange, setDateRange] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState('');

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState('');
  const [paymentAuthorizer, setPaymentAuthorizer] = React.useState([]);



  const getPaymentAuthorizer = async () => {
    setIsLoading(true);

    try {
      const res = await Auth.fetch("/driverapp/get-payment-authorizers");
      if (res?.ack) {
        setPaymentAuthorizer(res?.payment_authorizers)
      } else {
        setType('error')
        setLoadMessage(res?.message)
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };



  const discountColumns = [
    {
      title: 'Action',
      key: 'action',
      align: 'center',
      dataIndex: '',
      render(record) {
        console.log('record', record)
        return (
          <div style={{ display: 'flex', justifyContent: 'center' }} onClick={(e) => e.stopPropagation()}>
            {/* {
            ((record?.delivery_discount_req_status === 1 && record?.type == 1) || (record?.payment_req_status === 1 && record?.type ==2)) ? (
                <EditFilled style={{ fontSize: '22px'}}  onClick={()=>handleSelect(record)}/>
            ) : (
                <EditFilled style={{ cursor: "no-drop"}} disabled/>

            )
            } */}
            {/* <EditFilled style={{ fontSize: '22px'}}  onClick={()=>handleSelect(record)}/> */}
            <Button type="primary" onClick={() => handleSelect(record)}>Select</Button>
          </div>
        );
      },
    },
    {
      title: "Status",
      render(record) {
        let statusText;
        let backgroundColor;
        let status;
        if (record.type == 1) {
          status = record.delivery_discount_req_status
        } else {
          status = record.payment_req_status
        }

        switch (status) {
          case 1:
            statusText = "Pending";
            backgroundColor = "#faad14";
            break;
          case 2:
            statusText = "Approved";
            backgroundColor = "#80cb80";
            break;
          default:
            statusText = "Rejected";
            backgroundColor = "red";
            break;
        }

        return {
          props: {
            style: {
              background: backgroundColor,
            },
          },
          children: <>{statusText}</>,
        };
      },
    },
    {
      title: 'Date',
      render: (record) => {
        return (
          <>
            <span>{dayjs(record.delivery_date).format(DATE_FORMAT)}</span>
          </>
        )
      },
      //  width: 100,
    },
    {
      title: 'Order No.',
      render: (text, record) => {
        return (
          <span>
            {record.invoice_no != null && record?.invoice_no != "" ? (
              <a
                href={`${config.netsuite_url}/app/accounting/transactions/custinvc.nl?id=${record.inv_internal_id}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {record.invoice_no}
              </a>
            ) : (
              <a
                href={`${config.netsuite_url}/app/accounting/transactions/salesord.nl?id=${record.internal_id}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {record.sale_order_no}
              </a>
            )}
          </span>
        );
      },
    },
    {
      title: 'Customer Code',
      dataIndex: "customer_name",
      render: (text, record) => {
        return <span><a href={`${config.netsuite_url}/app/common/entity/custjob.nl?id=${record.customer_internal_id}`} target="_blank">{record.customer_name}</a></span>;
      },
    },
    {
      title: 'Customer',
      key: "customer_project_id",
      dataIndex: "customer_project_id"
    },
    {
      title: 'Driver',
      key: "driver",
      dataIndex: "driver"
    },
    {
      title: 'Authorizer',
      render(record) {
        let statusText;
        if (record?.type == 1) {
          const authorizer = record.delivery_discount_auth_by
            ? paymentAuthorizer.find((obj) => obj.id == record.delivery_discount_auth_by)
            : null;
          statusText = authorizer
            ? `${authorizer.first_name} ${authorizer.last_name}`
            : "";
        } else {
          const authorizer = record.payment_auth_by
            ? paymentAuthorizer.find((obj) => obj.id == record.payment_auth_by)
            : null;
          statusText = authorizer
            ? `${authorizer.first_name} ${authorizer.last_name}`
            : "";
        }

        return {
          props: {},
          children: <>{statusText}</>,
        };
      }
    },
    {
      title: 'Sales Person',
      render: (text, record) => {
        return <span>{record?.customer_fields?.split("######")?.[0] || ""}</span>;
      },
    },
    {
      title: 'Credit Controler',
      render: (text, record) => {
        return <span>{record?.customer_fields?.split("######")?.[1] || ""}</span>;
      },
    },
    {
      title: 'Driver Notes',
      key: "notes",
      dataIndex: "notes"
    },
    {
      title: 'Authorizer Notes',
      render(record) {
        let statusText;
        if (record?.type == 1) {
          statusText = record?.delivery_discount_req_notes ? record?.delivery_discount_req_notes : ""
        } else {
          statusText = record?.payment_req_notes ? record?.payment_req_notes : ""
        }

        return {
          props: {

          },
          children: <>{statusText}</>,
        };
      }
    },

    {
      title: 'Request Type',
      render: (record) => {
        return <span>{AuthReqTypes.find(reading => reading.id === record?.approval_request_type)?.title || ""}</span>;
      },
    },
    {
      title: 'Reason',
      render(record) {
        let statusText;
        if (record?.type == 1) {
          statusText = "Delivery Discount"
        } else {
          statusText = "Payment Authorization"
        }

        return {
          props: {

          },
          children: <>{statusText}</>,
        };
      }
    },
    {
      title: 'Request time',
      // render: (text, record) => {
      //   return record?.type == 1 ? (record.delivery_discount_req_sent ? moment(record.delivery_discount_req_sent).format("YYYY-MM-DD HH:mm:ss") : "") : (record.payment_req_sent ? moment(record.payment_req_sent).format("YYYY-MM-DD HH:MM:SS") : "");
      // },
      render(record) {
        let statusText;
        if (record?.type == 1) {
          statusText = record.delivery_discount_req_sent ? dayjs(record.delivery_discount_req_sent).format(`${DEFAULT_DATE_FORMAT} HH:mm:ss`) : ""
        } else {
          statusText = record.payment_req_sent ? dayjs(record.payment_req_sent).format(`${DEFAULT_DATE_FORMAT} HH:mm:ss`) : ""
        }

        return {
          props: {

          },
          children: <>{statusText}</>,
        };
      }
    },
    {
      title: 'Response time',
      render(record) {
        let statusText;
        if (record?.type == 1) {
          statusText = record.delivery_discount_req_responded ? dayjs(record.delivery_discount_req_responded).format(`${DEFAULT_DATE_FORMAT} HH:mm:ss`) : ""
        } else {
          statusText = record.payment_req_responded ? dayjs(record.payment_req_responded).format(`${DEFAULT_DATE_FORMAT} HH:mm:ss`) : ""
        }

        return {
          props: {

          },
          children: <>{statusText}</>,
        };
      }
    },


  ];

  const handleSelect = (record) => {
    navigate(`/discounts/${record?.internal_id}/${Number(record?.type)}`)
    // setSelectedRecord(record)
    // setIsModalOpen(true);

  }

  const search = async (download) => {
    if (!dateRange || !dateRange[0] || !dateRange[1]) return;
    let search = {};
    if (dateRange[0]) search.start_date = dateRange[0].format(DEFAULT_DATE_FORMAT);
    if (dateRange[1]) search.end_date = dateRange[1].format(DEFAULT_DATE_FORMAT);
    if (selectedStatus) search.status = selectedStatus.id;
    if (page && pageChange) search.page = page;

    if (download) search.download = 1;
    showLoading(layoutDispatch)
    try {
      const res = await Auth.fetch("/route/get-payment-authorization-status", {
        method: "POST",
        body: JSON.stringify(search),
      });
      if (res?.ack) {
        if (download) {
          window.open(res.file_url, "_blank", "noreferrer");
        }
        else {
          setAllDiscounts(res?.payment_auth_statuses);
          setTotalPages(Math.ceil(res.total_count / limit));
          setTotalCount(res.total_count);
          message.success(res?.message)
        }

      } else {
        setAllDiscounts([]);
        message.error(res?.message)
      }
    } catch (err) {
      console.log(err);
      message.error('something went wrong')
    } finally {
      hideLoading(layoutDispatch)
    }

  };

  const handleChange = (event, value) => {
    setPage(value);
    setPageChange(true)
  };

  useEffect(() => {
    const searchTimeout = setTimeout(() => search(), 1000);
    const intervalId = setInterval(() => search(), 30000);

    return () => {
      clearTimeout(searchTimeout);
      clearInterval(intervalId);
    };
  }, [dateRange, selectedStatus, page]);

  useLayoutEffect(() => {
    getPaymentAuthorizer()
  }, [])



  const [screenWidth, setScreenWidth] = React.useState("");

  const handleResize = () => {
    setScreenWidth(window.innerWidth);
  };

  React.useEffect(() => {
    setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const updateFilters = (newValues) => {
    const existingFiltersString = localStorage.getItem('DiscountFilters');
    let existingFilters = {};
    if (existingFiltersString) {
      try {
        existingFilters = JSON.parse(existingFiltersString);
      } catch (e) {
        console.error("Error parsing DiscountFilters from localStorage", e);
      }
    }
    Object.assign(existingFilters, newValues);
    existingFilters.timestamp = new Date().getTime();
    const updatedFiltersString = JSON.stringify(existingFilters);
    localStorage.setItem('DiscountFilters', updatedFiltersString);
  };

  const getFiltersOrDefault = () => {
    const existingFiltersString = localStorage.getItem('DiscountFilters');
    let existingFilters = {};
    if (existingFiltersString) {
      try {
        existingFilters = JSON.parse(existingFiltersString);
      } catch (e) {
        console.error("Error parsing DiscountFilters from localStorage", e);
      }
    }
    const currentTime = new Date().getTime();
    const expirationTime = 30 * 60 * 1000;
    if (existingFilters.timestamp && currentTime - existingFilters.timestamp < expirationTime) {

      if (!existingFilters.status) {
        existingFilters.status = '';
      }
      return existingFilters;
    } else {
      localStorage.removeItem('DiscountFilters');
      return {};
    }
  };

  useEffect(() => {
    const initialState = getFiltersOrDefault();
    if (!initialState?.status) {
      setSelectedStatus({ id: 1, title: "Pending" });
    } else {
      setSelectedStatus(initialState?.status);
    }

    if (initialState?.dateRange && initialState.dateRange[0]) {
      setDateRange([dayjs(initialState.dateRange[0]), dayjs(initialState.dateRange[1])]);
    } else {
      setDateRange([dayjs(currentDate), dayjs(currentDate)]);
      initialState.dateRange = [dayjs(currentDate).format(DEFAULT_DATE_FORMAT), dayjs(currentDate).format(DEFAULT_DATE_FORMAT)];
    }

    initialState.timestamp = new Date().getTime();
    updateFilters(initialState)
  }, []);

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>

        <h2 style={{ margin: 0 }}>Discounts</h2>
        <Button
          style={{ float: "right" }}
          type="primary"
          size='large'
          icon={<DownloadOutlined />}
          onClick={() => { search(1) }}
        >
          Download
        </Button>
      </div>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={6} lg={4} xl={2}>
          <label htmlFor="pcnDate">Date:</label>
          <RangePicker
            format={DATE_FORMAT}
            style={{ width: '100%' }}
            size="large"
            value={dateRange}
            onChange={(dates) => {
              if (dates && dates[1].diff(dates[0], 'day') > 31) {
                message.error("The date range cannot exceed 31 days.");
                return;
              }
              setDateRange(dates);
              updateFilters({
                dateRange: dates ? [dates[0].format(DEFAULT_DATE_FORMAT), dates[1].format(DEFAULT_DATE_FORMAT)] : null,
              });
              setPageChange(false);
              setPage(1);
            }}
            allowClear={true}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3} lg={2} xl={1.5}>
          <label htmlFor="Status">Status</label>
          <Autocomplete
            size="small"
            id="Status-type"
            options={discountStatus}
            getOptionLabel={(option) => option.title ? option.title : ''}
            value={selectedStatus}
            onChange={(e, values) => {
              setSelectedStatus(values);
              updateFilters({ status: values })
              setPageChange(false)
              setPage(1)

            }}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Status"
              />
            )}
          />
        </Grid>
      </Grid>


      <Table
        columns={discountColumns}
        scroll={{ x: "max-content" }}
        pagination={false}
        bordered
        dataSource={allDiscounts}
        loading={isLoading}
        // footer={() => `List of Discounts - Total Records: ${allDiscounts?.length === 0 ? "0" : allDiscounts?.length}`}
        footer={() => {
          const startRecord = (page - 1) * limit + 1;
          const endRecord = Math.min(page * limit, allDiscounts.length ? totalCount : 0);
          return `Showing ${startRecord}-${endRecord} of ${allDiscounts.length ? totalCount : "0"} Records`;
        }}
      />

      <div style={{ float: "right", margin: "10px" }}>
        <Pagination
          page={page}
          count={totalPages}
          variant="outlined"
          color="primary"
          onChange={handleChange}
        />
      </div>
      <Message type={type} msg={loadMessage} />
    </div>
  );
}
